// REST klient pro eshop-vsk-be.
// BE URL: 1) window.env.API_URL (deploy runtime-config), 2) odvození z window.location
// (eshop-vsk-fe-<env> → eshop-vsk-be-<env>), 3) lokální fallback http://localhost:8080.

function apiBase() {
  const fromEnv = (window.env && window.env.API_URL) || "";
  if (fromEnv && !fromEnv.includes("localhost")) {
    return fromEnv.replace(/\/$/, "");
  }
  const { hostname, protocol } = window.location;
  if (hostname.includes("-fe-")) {
    return `${protocol}//${hostname.replace("-fe-", "-be-")}`;
  }
  return "http://localhost:8080";
}

export const API_BASE = apiBase();

async function request(path, { method = "GET", body, auth = false } = {}) {
  const opts = {
    method,
    headers: { "Content-Type": "application/json" },
  };
  if (auth) opts.credentials = "include"; // session cookie pro admin
  if (body !== undefined) opts.body = JSON.stringify(body);

  const resp = await fetch(`${API_BASE}${path}`, opts);
  const text = await resp.text();
  const data = text ? JSON.parse(text) : null;
  if (!resp.ok) {
    const err = new Error((data && data.error && data.error.message) || `HTTP ${resp.status}`);
    err.status = resp.status;
    err.code = data && data.error && data.error.code;
    throw err;
  }
  return data;
}

// --- public ---
export const getProduct = () => request("/api/product");
export const getVersion = () => request("/api/version");
export const createOrder = (payload) => request("/api/orders", { method: "POST", body: payload });

// --- auth ---
export const authMe = () => request("/auth/me", { auth: true });
export const logout = () => request("/auth/logout", { method: "POST", auth: true });
export const loginUrl = () => `${API_BASE}/auth/login`;

// --- admin ---
const admin = (path, opts = {}) => request(`/api/admin${path}`, { ...opts, auth: true });
export const adminDashboard = () => admin("/dashboard");
export const adminOrders = (status) => admin(`/orders${status ? `?status=${status}` : ""}`);
export const adminOrder = (id) => admin(`/orders/${id}`);
export const adminOrderAction = (id, action) => admin(`/orders/${id}/${action}`, { method: "POST" });
export const adminStock = () => admin("/stock");
export const adminAddMovement = (payload) => admin("/stock/movements", { method: "POST", body: payload });
export const adminTransfer = (payload) => admin("/stock/transfer", { method: "POST", body: payload });
export const adminProduct = () => admin("/product");
export const adminUpdateProduct = (payload) => admin("/product", { method: "PUT", body: payload });
export const adminVariants = () => admin("/variants");
export const adminAddVariant = (payload) => admin("/variants", { method: "POST", body: payload });
export const adminUpdateVariant = (id, payload) =>
  admin(`/variants/${id}`, { method: "PUT", body: payload }); // PUT (ne PATCH — ingress)

// správa uživatelů (jen superadmin)
export const adminUsers = () => admin("/users");
export const adminAddUser = (payload) => admin("/users", { method: "POST", body: payload });
export const adminUpdateUser = (id, payload) =>
  admin(`/users/${id}`, { method: "PUT", body: payload }); // PUT (ne PATCH — ingress)
export const adminDeleteUser = (id) => admin(`/users/${id}`, { method: "DELETE" });

// danger zone (jen superadmin) — vynuluje data (produkt/objednávky/sklad)
export const adminResetDb = () => admin("/db/reset", { method: "POST" });

// inventura + korekce + pokladna
export const adminSubmitInventory = (payload) => admin("/inventory", { method: "POST", body: payload });
export const adminCorrections = () => admin("/corrections");
export const adminApproveCorrection = (id) => admin(`/corrections/${id}/approve`, { method: "POST" });
export const adminRejectCorrection = (id) => admin(`/corrections/${id}/reject`, { method: "POST" });
export const adminCash = () => admin("/cash");
export const adminSaveCash = (payload) => admin("/cash/count", { method: "POST", body: payload });
export const adminStockTakes = () => admin("/stock-takes");
export const adminStockTakeAction = (id, action) => admin(`/stock-takes/${id}/${action}`, { method: "POST" });
export const adminCashCountAction = (id, action) => admin(`/cash-counts/${id}/${action}`, { method: "POST" });
export const adminMoneyCorrectionAction = (id, action) => admin(`/money-corrections/${id}/${action}`, { method: "POST" });

// aplikační log (audit + chyby) — jen superadmin
export const adminLogs = () => admin("/logs");
export const adminAckLogs = () => admin("/logs/ack", { method: "POST" });

// superadmin override stavu objednávky (opravný prostředek)
export const adminOverrideStatus = (id, status) =>
  admin(`/orders/${id}/status`, { method: "PUT", body: { status } });

// přeplatek (dýško) → ostatní (admin)
export const adminSetOther = (id, amount) =>
  admin(`/orders/${id}/other`, { method: "PUT", body: { amount } });

// interní poznámka k objednávce (admin)
export const adminSetNote = (id, note) =>
  admin(`/orders/${id}/note`, { method: "PUT", body: { note } });

// superadmin: editace údajů objednávky (kontakt/doručení/platba/poznámky)
export const adminEditOrder = (id, payload) =>
  admin(`/orders/${id}/edit`, { method: "PUT", body: payload });
